<main class="w-full">
	@if (itemLabel) {
		<lbca-input-text-condensed
			[tabeled]="false"
			[labeled]="false"
			[label]="itemLabel"
			[error]="[]"
			[value]="checkedItens"
		></lbca-input-text-condensed>
	}
	@if (!itemLabel) {
		<lbca-input-text
			[tabeled]="true"
			[labeled]="false"
			[error]="[]"
			[value]="checkedItens"
		></lbca-input-text>
	}
</main>
